// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,

  //------------ generated on 1 April 2025---------------- next sep 30-2025 // 
  //apple_developer_token: "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkdYNFA5ODNCV0oifQ.eyJpYXQiOjE3Mjc2OTE5NDEsImV4cCI6MTc0MzI0Mzk0MSwiaXNzIjoiMlQ3U0I0WkNaNiJ9.eJvmvmgr3FDScKO_8nWtXUeclbW-L9w8wjq2jiI7SvEBNkcRhTQqmQOjR7wNMcmrB1ZWZLD9T2F83s2_fEGbAA",
  //apple_developer_token: "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkdYNFA5ODNCV0oifQ.eyJpYXQiOjE3NTkxMjcwODksImV4cCI6MTc3NDY3OTA4OSwiaXNzIjoiMlQ3U0I0WkNaNiJ9.xSzy2lwP4sI727eSzobqEA1dJqXLgdWaYHsY5VljiwgjSCIL0A3h3aeJ5HDMq7_LppXyT7L-DhO7_jDQU9haeQ",
    apple_developer_token: "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkdYNFA5ODNCV0oifQ.eyJpYXQiOjE3NzQ4NTQ0MjksImV4cCI6MTc5MDQwNjQyOSwiaXNzIjoiMlQ3U0I0WkNaNiJ9.8_YiiNkk0lsLbTyonBnIEOUVDOW3HQuWuV6LnG8gVAC2Z_9atYYxnMk2W4ZjybQA_ksWXzH0SXvjb_mZ3fvztg"
  };
  
  /*
  node musickit-token-encoder.js subscription brach
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
  